import React, { Component } from "react";
import { Link } from "react-router-dom";
import isEmpty from "../../validation/is-empty";
//import Moment from "react-moment";

class BrusselItem extends Component {
  render() {
    const { brussel } = this.props;

    return (
      <div className="card card-body mb-3 m-auto rounded">
        <div className="row d-flex flex-row col-lg-6 justify-content-between">
          <div className="col-lg-6 col-md-4 text-center col-sm-12 shadow-lg p-lg-3 mb-lg-3 pb-sm-2 mb-sm-2 bg-body border border-info border-rounded rounded">
            <p className="text-info">
              <em>
                Looking for a room in <strong>{brussel.ru_id} </strong> ||
                Domiciliation:
                {isEmpty(brussel.verified) ? null : (
                  <span>{brussel.neigbourhood}</span>
                )}{" "}
              </em>{" "}
            </p>
            {/* {brussel.totalExp ? <p>Min Stay: {brussel.totalExp}</p> : null}

            {isEmpty(brussel.maxbudget) ? null : (
              <p>
                <span>
                  {" "}
                  Max budget:<strong> {brussel.maxbudget}€ </strong>
                </span>
              </p>
            )} */}

            <p>
              {isEmpty(brussel.city) ? null : <span>{brussel.city}</span>}

              {/* {brussel.location_city ? "," : null}
              {isEmpty(brussel.location_country) ? null : (
                <span>{brussel.location_country}</span>
              )}*/}
            </p>
{/*  */}
            <Link
              to={`${brussel.link}`}
              className="btn bg-info text-white shadow-lg shadow-md p-2 mb-2  rounded border border-dark mb-2"
            >
              <h6> View Mission</h6>
            </Link>
          </div>
          <div
            className="col-md-4 bg-info   "
            style={{
              textAlign: "center",
              borderTopRightRadius: "10%",

              borderBottomRightRadius: "25%",
            }}
          >
            <h6 className="pt-2 m-1 " style={{ fontSize: "12px" }}>
              {" "}
              <strong>Neigbourhoods</strong>
            </h6>
          </div>
        </div>
      </div>
    );
  }
}



export default BrusselItem;
